export default __webpack_public_path__ + "static/media/img-postal.4d4d2e9f.png";